import { render, staticRenderFns } from "./ForumDetails.vue?vue&type=template&id=73e83d16&scoped=true&"
import script from "./ForumDetails.vue?vue&type=script&lang=js&"
export * from "./ForumDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e83d16",
  null
  
)

export default component.exports